<mat-toolbar fxlayoutalign="center center" style="place-content: center;" class="index-menu">
    <button mat-button [matMenuTriggerFor]="introduction">認識中正</button>
        <mat-menu #introduction="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="Administrative">行政組織</button>
            <button mat-menu-item [matMenuTriggerFor]="students">學生與校園</button>     
        </mat-menu>
            <mat-menu #Administrative="matMenu"  >
                <div *ngFor="let menu of menusJson">
                    <div  *ngIf="menu.layer == 'Administrative'">
                        <a href="{{menu.url}}" target="_blank" mat-menu-item>{{menu.text}}</a>
                    </div>
                </div>
            </mat-menu>
            <mat-menu #students="matMenu">
                <div *ngFor="let menu of menusJson">
                    <div  *ngIf="menu.layer == 'students'">
                        <a href="{{menu.url}}" target="_blank" mat-menu-item>{{menu.text}}</a>
                    </div>
                </div>
            </mat-menu>
    <button mat-button [matMenuTriggerFor]="bulletin">學校公告</button>
        <mat-menu #bulletin="matMenu">
            <div *ngFor="let menu of menusJson">
                <div  *ngIf="menu.layer == 'bulletin'">
                    <a href="{{menu.url}}" target="_blank" mat-menu-item>{{menu.text}}</a>
                </div>
            </div>
        </mat-menu>
  
    <button mat-button [matMenuTriggerFor]="campusSystem">校園系統</button>
        <mat-menu #campusSystem="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="educationDep">教務處</button>
            <button mat-menu-item [matMenuTriggerFor]="studentDep">學務處</button>
            <button mat-menu-item [matMenuTriggerFor]="generalDep">總務處</button>     
        </mat-menu>
            <mat-menu #educationDep="matMenu"  >
                <div *ngFor="let menu of menusJson">
                    <div  *ngIf="menu.layer == 'educationDep'">
                        <a href="{{menu.url}}" target="_blank" mat-menu-item>{{menu.text}}</a>
                    </div>
                </div>
            </mat-menu>
            <mat-menu #studentDep="matMenu">
                <div *ngFor="let menu of menusJson">
                    <div  *ngIf="menu.layer == 'studentDep'">
                        <a href="{{menu.url}}" target="_blank" mat-menu-item>{{menu.text}}</a>
                    </div>
                </div>
            </mat-menu>   
            <mat-menu #generalDep="matMenu">   
                <div *ngFor="let menu of menusJson">
                    <div  *ngIf="menu.layer == 'generalDep'">
                        <a href="{{menu.url}}" target="_blank" mat-menu-item>{{menu.text}}</a>
                    </div>
                </div>
            </mat-menu> 

    <button mat-button [matMenuTriggerFor]="learning">學習平台</button>
        <mat-menu #learning="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="evaluation">評量</button> 
            <button mat-menu-item [matMenuTriggerFor]="questionnaire">問卷</button>
            <button mat-menu-item [matMenuTriggerFor]="digitalLearning">數位學習</button>
        </mat-menu>
            <mat-menu #evaluation="matMenu"  >
                <div *ngFor="let menu of menusJson">
                    <div  *ngIf="menu.layer == 'evaluation'">
                        <a href="{{menu.url}}" target="_blank" mat-menu-item>{{menu.text}}</a>
                    </div>
                </div>
            </mat-menu>
            <mat-menu #digitalLearning="matMenu"  >
                <div *ngFor="let menu of menusJson">
                    <div  *ngIf="menu.layer == 'digitalLearning'">
                        <a href="{{menu.url}}" target="_blank" mat-menu-item>{{menu.text}}</a>
                    </div>
                </div>
            </mat-menu>
            <mat-menu #questionnaire="matMenu"  >
                <div *ngFor="let menu of menusJson">
                    <div  *ngIf="menu.layer == 'questionnaire'">
                        <a href="{{menu.url}}" target="_blank" mat-menu-item>{{menu.text}}</a>
                    </div>
                </div>
            </mat-menu>
    <a href="http://ncp.phc.edu.tw/show/?109&164602" target="_blank" class="mat-button mat-button-base horizontal-active-link" fxHide fxShow.gt-sm> 總體課程計畫</a>
</mat-toolbar>